import createSetPriceBooking from './setPriceCurrentBooking';
import { priceBookingVar } from '../reactiveVariables';

const setPriceCurrentBooking = createSetPriceBooking(priceBookingVar);

export default setPriceCurrentBooking;
